export enum LorenGeofencingType {
    POLYGON = 'POLYGON',
    CIRCLE = 'CIRCLE',
    RECTANGLE = 'RECTANGLE'
}
